import { businessData as businessDataAtom } from 'atoms';
import Loader from 'common/Loaders/Loader';
import InnerPageLayout from 'pages/Business/Partials/InnerPageLayout';
import EmptyProviderHome from 'pages/Business/Provider/EmptyProviderHome';
import ProviderPopup from 'pages/Business/Provider/ProviderPopup';
import ProviderTable from 'pages/Business/Provider/ProviderTable';
import { useRecoilState } from 'recoil';
import { toasterNotification } from 'utils/toaster';
import { useAuth } from 'context/AuthContext';

import React, { useEffect, useState } from 'react';

const ProviderHome = () => {
    const { token, loading: authLoading } = useAuth();
    const [business] = useRecoilState(businessDataAtom);
    const [openPopup, setOpenPopup] = useState(false);
    const [providerList, setProviderList] = useState(null);
    const [rows, setRows] = useState([]);
    const [selectedProvider, setSelectedProvider] = useState({});
    const [formState, setFormState] = useState('add');
    const [loading, setLoading] = useState(false);
    const [providerLoading, setProviderLoading] = useState(false);

    const mergeAvailability = (availability) => {
        const groupedBySlot = availability.reduce((acc, item) => {
            if (!item) return acc;
            const { day, start_datetime: start, end_datetime: end } = item;
            if (day === undefined || start === undefined || end === undefined) {
                acc.__raw__.push(item);
                return acc;
            }
            const key = `${day}|${start}|${end}`;
            if (!acc[key]) acc[key] = [];
            acc[key].push(item);
            return acc;
        }, { __raw__: [] });

        const merged = [];
        Object.keys(groupedBySlot).forEach((key) => {
            if (key === '__raw__') {
                groupedBySlot[key].forEach((row) => merged.push(row));
                return;
            }
            const rows = groupedBySlot[key];
            if (rows.length === 2) {
                const teleRow = rows.find(
                    (r) =>
                        (r.is_telemedicine === true || r.is_telemedicine === '1') &&
                        (String(r.location) === '0' || r.location === 0 || r.location === null),
                );
                const inPersonRow = rows.find(
                    (r) =>
                        (r.is_telemedicine === false || r.is_telemedicine === '0' || r.is_telemedicine === null) &&
                        r.location !== null &&
                        String(r.location) !== '0',
                );
                const createdAtMatches =
                    teleRow && inPersonRow &&
                    teleRow.created_at && inPersonRow.created_at &&
                    String(teleRow.created_at) === String(inPersonRow.created_at);
                if (teleRow && inPersonRow && createdAtMatches) {
                    merged.push({
                        day: teleRow.day,
                        start_datetime: teleRow.start_datetime,
                        end_datetime: teleRow.end_datetime,
                        location: inPersonRow.location,
                        is_telemedicine: true,
                    });
                    return;
                }
            }
            rows.forEach((row) => merged.push(row));
        });
        return merged;
    };

    const processServices = (serviceDataRaw) => {
        const serviceData = Array.isArray(serviceDataRaw) ? serviceDataRaw : (serviceDataRaw ? [serviceDataRaw] : []);
        const incompleteServices = serviceData.filter(item => item.service_id === -1);
        const completeServiceData = serviceData.filter(item => item.service_id !== -1);

        const serviceGroups = {};
        completeServiceData.forEach((item) => {
            if (!serviceGroups[item.service_id]) serviceGroups[item.service_id] = [];
            serviceGroups[item.service_id].push(item);
        });

        const processedServices = [];
        const serviceVisitModes = [];

        Object.keys(serviceGroups).forEach((serviceId) => {
            const group = serviceGroups[serviceId];
            if (group.length === 2) {
                const inPerson = group.find(item => item.is_telemedicine === false);
                const telemedicine = group.find(item => item.is_telemedicine === true);
                if (inPerson && telemedicine &&
                    inPerson.price === telemedicine.price &&
                    inPerson.duration === telemedicine.duration &&
                    inPerson.bookable === telemedicine.bookable) {
                    processedServices.push({ service_id: Number(serviceId), price: inPerson.price, duration: inPerson.duration, bookable: inPerson.bookable, is_telemedicine: false });
                    serviceVisitModes.push('both');
                } else {
                    group.forEach(item => { processedServices.push(item); serviceVisitModes.push(item.is_telemedicine ? 'telemedicine' : 'in_person'); });
                }
            } else {
                group.forEach(item => {
                    processedServices.push(item);
                    serviceVisitModes.push(item.bookable === false ? 'not_available' : (item.is_telemedicine ? 'telemedicine' : 'in_person'));
                });
            }
        });

        const services = processedServices.map((item) => item.service_id);
        const serviceDuration = processedServices.map((item) => item.duration);
        const servicePrice = processedServices.map((item) => item.price);
        const serviceTelemedecine = processedServices.map((item) => item.is_telemedicine);
        const serviceBookable = processedServices.map((item) => item.bookable !== undefined ? item.bookable : true);

        if (incompleteServices.length > 0) {
            const incompleteGroups = {};
            incompleteServices.forEach(item => {
                const key = `${item.price}_${item.duration}_${item.bookable}`;
                if (!incompleteGroups[key]) incompleteGroups[key] = [];
                incompleteGroups[key].push(item);
            });
            Object.keys(incompleteGroups).forEach(key => {
                const group = incompleteGroups[key];
                if (group.length === 2) {
                    const inPerson = group.find(item => item.is_telemedicine === false);
                    const telemedicine = group.find(item => item.is_telemedicine === true);
                    if (inPerson && telemedicine) {
                        services.push(''); servicePrice.push(inPerson.price || ''); serviceDuration.push(inPerson.duration || '');
                        serviceTelemedecine.push(false); serviceBookable.push(inPerson.bookable !== undefined ? inPerson.bookable : true);
                        serviceVisitModes.push('both');
                    } else {
                        group.forEach(incomplete => {
                            services.push(''); servicePrice.push(incomplete.price || ''); serviceDuration.push(incomplete.duration || '');
                            serviceTelemedecine.push(incomplete.is_telemedicine || false); serviceBookable.push(incomplete.bookable !== undefined ? incomplete.bookable : true);
                            serviceVisitModes.push(incomplete.is_telemedicine ? 'telemedicine' : 'in_person');
                        });
                    }
                } else {
                    const incomplete = group[0];
                    services.push(''); servicePrice.push(incomplete.price || ''); serviceDuration.push(incomplete.duration || '');
                    serviceTelemedecine.push(incomplete.is_telemedicine || false); serviceBookable.push(incomplete.bookable !== undefined ? incomplete.bookable : true);
                    serviceVisitModes.push(incomplete.bookable === false ? 'not_available' : (incomplete.is_telemedicine ? 'telemedicine' : 'in_person'));
                }
            });
        }

        return { services, serviceDuration, servicePrice, serviceTelemedecine, serviceBookable, serviceVisitModes };
    };

    const transformProviderFullData = (item) => {
        // API returns { provider: {...}, availability: [], specialities: [], ... }
        const providerData = item.provider ?? item;
        const education = Array.isArray(item.education) ? item.education : [];
        const certificates = Array.isArray(item.certificates) ? item.certificates : [];
        const qualifications = Array.isArray(item.qualifications) ? item.qualifications : [];
        const specialities = Array.isArray(item.specialities) ? item.specialities : [];
        const licenses = Array.isArray(item.licenses) ? item.licenses : [];
        const availabilityRaw = Array.isArray(item.availability) ? item.availability : [];
        const servicesRaw = Array.isArray(item.services) ? item.services : [];

        const mergedAvailability = mergeAvailability(availabilityRaw);
        const { services, serviceDuration, servicePrice, serviceTelemedecine, serviceBookable, serviceVisitModes } = processServices(servicesRaw);

        return {
            ...providerData,
            gender: providerData.sex,
            education_degree: education.map((e) => e.degree),
            education_field: education.map((e) => e.field_of_study),
            education_institute: education.map((e) => e.institution_name),
            board_certification: certificates.map((c) => c.certification),
            board_certification_state: certificates.map((c) => c.state),
            board_certification_year: certificates.map((c) => c.year),
            qualification_title: qualifications.map((q) => q.qualification),
            qualifications: qualifications.map((q) => q.qualification),
            speciality: specialities.map((s) => s.speciality),
            specialties: specialities.map((s) => s.speciality),
            categories: specialities.map((s) => s.category),
            license_number: licenses.map((l) => l.license_number),
            license_state: licenses.map((l) => l.state),
            license_year: licenses.map((l) => l.year),
            availability: mergedAvailability.length > 0,
            availability_day: mergedAvailability.map((a) => a.day),
            availability_start_time: mergedAvailability.map((a) => a.start_datetime),
            availability_end_time: mergedAvailability.map((a) => a.end_datetime),
            availability_location: mergedAvailability.map((a) => a.location),
            telemedicine: mergedAvailability.map((a) => a.is_telemedicine),
            services,
            service_price: servicePrice,
            service_duration: serviceDuration,
            service_telemedecine: serviceTelemedecine,
            service_bookable: serviceBookable.length === 0 && services.length > 0 ? services.map(() => true) : serviceBookable,
            service_visit_mode: serviceVisitModes || [],
            in_person_consultation_duration: providerData.in_person_consultation_duration,
            in_person_consultation_price: providerData.in_person_consultation_price ?? null,
            telemedicine_consultation_duration: providerData.telemedicine_consultation_duration,
            telemedicine_consultation_price: providerData.telemedicine_consultation_price ?? null,
            telemedicine_url: providerData.telemedicine_url,
        };
    };

    const getProviderList = async () => {
        setLoading(true);
        try {
            if (!business?.id) {
                setProviderList([]);
                return;
            }
            if (authLoading) {
                return;
            }
            if (!token) {
                toasterNotification('error', '', 'Authentication error. Please try again.');
                setProviderList([]);
                return;
            }

            const response = await fetch(
                `${process.env.REACT_APP_SERVER_URL}/api/providers/provider-full-details`,
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`,
                    },
                    body: JSON.stringify({ business_id: business.id, status: 'All' }),
                }
            );

            const result = await response.json();

            if (!response.ok || result.error) {
                toasterNotification('error', '', result.error || 'Failed to fetch providers');
                setProviderList([]);
                return;
            }

            const data = result.data;
            const providerData = Array.isArray(data) ? data : (data ? [data] : []);

            // Sync status for approved providers still showing 'In Review'
            const needsUpdate = providerData.filter(
                (p) => p.is_approved === true && p.status === 'In Review'
            );
            if (needsUpdate.length > 0) {
                await Promise.all(
                    needsUpdate.map((p) =>
                        fetch(`${process.env.REACT_APP_SERVER_URL}/api/providers/provider/${p.id}`, {
                            method: 'PUT',
                            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
                            body: JSON.stringify({ status: 'Active' }),
                        })
                    )
                );

                const refetchResponse = await fetch(
                    `${process.env.REACT_APP_SERVER_URL}/api/providers/provider-full-details`,
                    {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
                        body: JSON.stringify({ business_id: business.id, status: 'All' }),
                    }
                );
                const refetchResult = await refetchResponse.json();
                if (!refetchResponse.ok || refetchResult.error) {
                    setProviderList(providerData);
                } else {
                    const rd = refetchResult.data;
                    setProviderList(Array.isArray(rd) ? rd : (rd ? [rd] : []));
                }
            } else {
                setProviderList(providerData);
            }
        } catch (error) {
            console.error('Error in getProviderList:', error);
            toasterNotification('error', '', 'An unexpected error occurred. Please try again.');
            setProviderList([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (business?.id) getProviderList().then();
    }, [business]);

    const togglePopup = (e) => {
        try {
            if (e?.row) {
                const fullProvider = providerList?.find((item) => (item.provider ?? item).id === e.row.id);
                if (fullProvider) {
                    setProviderLoading(true);
                    const transformed = transformProviderFullData(fullProvider);
                    setFormState('edit');
                    setSelectedProvider(transformed);
                    setProviderLoading(false);
                }
                setOpenPopup(!openPopup);
                return;
            }
            setSelectedProvider({});
            setFormState('add');
            setOpenPopup(!openPopup);
        } catch (error) {
            return;
        }
    };

    useEffect(() => {
        try {
        if (providerList?.length > 0) {
            let rows = providerList?.map((item) => {
                const p = item.provider ?? item;
                return {
                    id: p.id,
                    status: p.status,
                    name: p.first_name + ' ' + p.last_name,
                    handle: p.handle,
                    email: p.email,
                };
            });
            setRows(rows);
        }
                    
    } catch (error) {
 
    }
    }, [providerList]);

    return (
        <div className="h-full bg-[#F5F1ED]" style={{ display: 'flex', flexDirection: 'column', flex: 1, height: '100%' }}>
            {loading ? (
                <Loader />
            ) : (
                <>
                    {providerList?.length === 0 && <EmptyProviderHome togglePopup={togglePopup}></EmptyProviderHome>}

                    {providerList?.length > 0 && (
                        <InnerPageLayout togglePopup={togglePopup} heading="Providers" btnText="Add a Provider" buttonType="secondary">
                            <ProviderTable
                                rows={rows}
                                handleRowClick={togglePopup}
                                setProviderList={setProviderList}
                                getProviderList={getProviderList}
                            ></ProviderTable>
                        </InnerPageLayout>
                    )}

                    <ProviderPopup
                        open={openPopup}
                        onClose={togglePopup}
                        getProviderList={getProviderList}
                        selectedProvider={selectedProvider}
                        setSelectedProvider={setSelectedProvider}
                        formState={formState}
                        setFormState={setFormState}
                        businessId={business?.id}
                        loading={providerLoading} // Pass the loading state to the popup
                        setProviderLoading={setProviderLoading}

                    />
                </>
            )}
        </div>
    );
};

export default ProviderHome;
